import { Action } from 'redux';
import {ProjectResource} from "../../resources/artifacts/project/projectResource";

export enum SystemActionTypes {
    SYSTEM_FILE_LOAD_REQUEST = 'SYSTEM_FILE_LOAD_REQUEST',
    SYSTEM_FILE_LOAD_SUCCESS = 'SYSTEM_FILE_LOAD_SUCCESS',
    SYSTEM_FILE_LOAD_FAILURE = 'SYSTEM_FILE_LOAD_FAILURE',

    SYSTEM_PERSIST_REQUEST = 'SYSTEM_PERSIST_REQUEST',
    SYSTEM_PERSIST_SUCCESS = 'SYSTEM_PERSIST_SUCCESS',
    SYSTEM_PERSIST_FAILURE = 'SYSTEM_PERSIST_FAILURE',
}

export type SystemLoadAction = SystemLoadRequest | SystemLoadSuccess | SystemLoadFailure;
export type SystemPersistAction = SystemPersistRequest | SystemPersistSuccess | SystemPersistFailure;
export type SystemAction =
    | SystemLoadAction
    | SystemPersistAction

export interface SystemLoadRequest extends Action {
    type: SystemActionTypes.SYSTEM_FILE_LOAD_REQUEST;
    payload: {
        filepath: string;
    };
}

export interface SystemLoadSuccess extends Action {
    type: SystemActionTypes.SYSTEM_FILE_LOAD_SUCCESS;
    payload: {
        filepath: string;
    };
}

export interface SystemLoadFailure extends Action {
    type: SystemActionTypes.SYSTEM_FILE_LOAD_FAILURE;
    payload: {
        errorMessage: string;
    };
}

export interface SystemPersistRequest extends Action {
    type: SystemActionTypes.SYSTEM_PERSIST_REQUEST;
    payload: {
        filepath: string;
    };
}

export interface SystemPersistSuccess extends Action {
    type: SystemActionTypes.SYSTEM_PERSIST_SUCCESS;
    payload: {
        filepath: string;
        system: ProjectResource;
    };
}

export interface SystemPersistFailure extends Action {
    type: SystemActionTypes.SYSTEM_PERSIST_FAILURE;
    payload: {
        errorMessage: string;
    };
}